import { useFilters } from "../../contexts/FilterContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export const SortSelector = () => {
  const { filters, updateFilter } = useFilters();

  return (
    <Select value={filters.sortBy} onValueChange={(value) => updateFilter("sortBy", value)}>
      <SelectTrigger className="w-[180px] focus:ring-igbanwo-mint">
        <SelectValue placeholder="Sort by"/>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="newest">Newest First</SelectItem>
        <SelectItem value="oldest">Oldest First</SelectItem>
      </SelectContent>
    </Select>
  );
};